"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFailed = exports.isPending = exports.isUninitialized = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var isUninitialized = function isUninitialized(requestStatus) {
  return requestStatus === _RequestStatusTypes.default.UNINITIALIZED;
};

exports.isUninitialized = isUninitialized;

var isPending = function isPending(requestStatus) {
  return requestStatus === _RequestStatusTypes.default.PENDING;
};

exports.isPending = isPending;

var isFailed = function isFailed(requestStatus) {
  return requestStatus === _RequestStatusTypes.default.FAILED;
};

exports.isFailed = isFailed;